import React, { AnchorHTMLAttributes, useMemo, JSX } from 'react';
import { FooterCol, FooterLinkType, FooterRow } from './Footer';
import { Col, Row } from 'reactstrap';

import NewsLetterInputRenderer from './NewsLetter';
import { createUniqueId } from '@ibe/services';

export const RowCreator = ({ cols, hide = false }: FooterRow): JSX.Element => {
  const keys = useMemo(() => cols.map(numb => `${numb}_${createUniqueId()}`), []);
  if (hide) return <></>;
  return (
    <Row>
      {cols.map((col, index) => (
        <ColCreator key={keys[index]} {...col} />
      ))}
    </Row>
  );
};

export const ColCreator = ({
  customContent,
  rowGrid,
  header,
  newsLetterInput,
  options,
  subCols
}: FooterCol) => {
  const keys = useMemo(() => (options || []).map(numb => `${numb}_${createUniqueId()}`), []);
  if (customContent) return <Col {...rowGrid}>{customContent}</Col>;
  if (subCols && subCols.length) {
    return (
      <Col {...rowGrid}>
        <RowCreator cols={subCols} />{' '}
      </Col>
    );
  }

  return (
    <Col {...rowGrid} className="footer-col">
      {header ? <HeaderRenderer {...header} /> : null}
      {newsLetterInput ? <NewsLetterInputRenderer {...newsLetterInput} /> : null}
      <div>
        {options
          ? options.map((option, index) => <LinkRenderer key={keys[index]} {...option} />)
          : null}
      </div>
    </Col>
  );
};

const HeaderRenderer = (props: FooterCol['header']) => {
  const { value, className, tag: Tag = 'h4' } = props || {};
  return <Tag className={className}>{value}</Tag>;
};

const LinkRenderer = (props: FooterLinkType): JSX.Element => {
  const {
    url,
    value,
    isActiveLink = true,
    openNewBrowserWindowOnClick,
    tag: Tag = 'a',
    customRenderer,
    className
  } = props;

  if (customRenderer) return customRenderer(props);

  const attr: AnchorHTMLAttributes<HTMLAnchorElement> = {
    href: url,
    className: `${className || ''} ${isActiveLink ? '' : 'iso__footer__link--disable'}`
  };

  const allAttributes: typeof attr = openNewBrowserWindowOnClick
    ? { ...attr, target: '_blank', rel: 'noopener noreferrer' }
    : attr;

  return (
    <Tag {...allAttributes}>
      <span>{value}</span>
    </Tag>
  );
};
